import { Upload } from 'lucide-react';

/**
 * Full-page drop target that appears when the user drags files
 * over the active page. Parent owns the state + file array;
 * this component is purely presentational.
 */
export function DropOverlay({
  visible,
  label = 'Отпустите файлы, чтобы прикрепить',
}: { visible: boolean; label?: string }) {
  if (!visible) return null;
  return (
    <div className="pointer-events-none absolute inset-0 z-30 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3 rounded-2xl border-2 border-dashed border-primary/50 bg-surface px-10 py-8 shadow-lg">
        <Upload size={32} className="text-primary" />
        <div className="text-center">
          <div className="text-[15px] font-medium">{label}</div>
          <div className="mt-1 text-[12px] text-muted-foreground">Up to 10 files · 50 MB each</div>
        </div>
      </div>
    </div>
  );
}
